
import { useQuery } from 'react-query';
import { VimeoPlayer } from '@/components/Elements';
import { PageLayout } from '@/components/Layout/PageLayout';
import { Spinner, MDPreview } from '@/components/Elements';
import { formatDate } from '@/utils/format';
import { ErrorMessage } from '@/types';
import { fetchIntro } from './api';
import { useNotificationStore } from '@/stores/notifications';
import { UpdateIntro } from './UpdateIntro';

export const Welcome = () => {
  const { addNotification } = useNotificationStore();
  const { data, isLoading } = useQuery('get-intro', () => fetchIntro(), {
    onError: (err: ErrorMessage) => {
      addNotification({
        type: 'success',
        title: err.message,
      });
    },
  });
  if (isLoading || !data) {
    return (
      <div className="w-full h-48 flex justify-center items-center">
        <Spinner size="lg" />
      </div>
    );
  }
  return (
      <PageLayout breadcrumbs={[{label:"Welcome Video"}]} addAction={<UpdateIntro />}>
        <span className="text-xs font-bold">{formatDate(data.createdAt)}</span>
        <div className="mt-6 flex flex-col space-y-16">
            <div className="bg-white shadow overflow-hidden sm:rounded-lg">
              <div className="px-4 py-5 sm:px-6">
                <div className="mt-1 max-w-2xl text-sm text-gray-500">
                  <VimeoPlayer vimeoId={data.vimeoId} />
                  <div className="mt-4 space-y-2 rounded-md border border-gray-200 bg-gray-50 p-4">
                    <p>
                      <span className="font-semibold text-gray-700">Title:</span>{' '}
                      {data.title || 'Not set'}
                    </p>
                    <p>
                      <span className="font-semibold text-gray-700">Button Text:</span>{' '}
                      {data.buttonText || 'Not set'}
                    </p>
                  </div>
                  <MDPreview
                    value={`Vimeo ID = ${data.vimeoId} with item id = ${data._id} | Enabled = ${
                      data.enabled ? 'Yes' : 'No'
                    }`}
                  />
                </div>
              </div>
            </div>
          </div>
        
      </PageLayout>
  );
};
